module.exports = __webpack_public_path__ + "static/media/inventory-tutorial-1.00054251.png";